import { productMidia } from 'enums/enums'
import CategoryIcon from '@mui/icons-material/Category'

export const getIconsGroups = (nmProduto: string) => {
  const extractKeyword = (text: string) => {
    const keywords = text.split('-')[0].trim().toUpperCase()
    return keywords
  }

  const normalizedNmProduto = extractKeyword(nmProduto)
  const matchedIcon = productMidia.find((item) =>
    item.nm_produto.some((produto) => produto.toUpperCase() === normalizedNmProduto)
  )

  return matchedIcon?.icon ?? <CategoryIcon style={{ color: '#1856ff', fontSize: '26px' }} />
}
